import { render } from "./InquiryExperiments.vue?vue&type=template&id=208e2626&scoped=true"
import script from "./InquiryExperiments.vue?vue&type=script&lang=js"
export * from "./InquiryExperiments.vue?vue&type=script&lang=js"

import "./InquiryExperiments.vue?vue&type=style&index=0&id=208e2626&scoped=true&lang=css"

import exportComponent from "D:\\Repos\\c2stem\\c2stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208e2626"]])

export default __exports__